import React, { useCallback, useRef, useState, useEffect  } from 'react'
import { SLowcodeList, STableActions, SActionBtn, SDrawer } from 'shj-components'
import { Button, Col, DatePicker, Row, Table, Tabs, Drawer, Dropdown, Space } from 'antd'
import { get } from 'lodash-es'
import styles from '../../index.module.less'
import FavoritesList from './favoritesList'
import {
  fastFunctionMenuSettingList,
  fastFunctionMenuSettingAddOrDel,

  getOrgList,
  getEnums,
  httpCompanyList,
  getTicketsChannelConfigTree,
  getTicketsInternalConfigTree,
  getTicketsExposureConfigTree,
} from '@/services/homeService'
import { useNavigate } from 'react-router-dom'
import { navigatePage } from '@/common/utils'
import { useFileUrlPrefix } from 'shj-utils'
import { useSetState } from 'ahooks'
import { AddOrEditDrawer } from '../addClue'
import EditDrawer from '../addStaff'
import { AddMatterModal } from '../addMatter'
import { dfs, convertListToTree, getTreeList, formatToTree } from '@/utils/common'
import { httpDictServ } from '@/services/customerServices'

const quickEntrance = (props: any) => {
  const navigate = useNavigate()
  const [visibleDrawer, setVisibleDrawer] = useState<Boolean>(false)
  const [isDel, setIsDel] = useState<boolean>(false)
  const [dataList, setDataList] = useState<Array>([])
  const [imagePrefix] = useFileUrlPrefix()
  const [shortcutIds, setShortcutIds] = useState<Array>([])
  const [menuIds, setMenuIds] = useState<Array>([])

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <a
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            setVisibleDrawer(true)
          }}
        >
          添加
        </a>
      ),
    },
    {
      key: '4',
      label: (
        <a
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            setIsDel(true)
          }}
        >
          快捷编辑
        </a>
      ),
    },
  ]

  const [addRefRecord, setAddRefRecord] = useState<any>(undefined)
  const [state, setState] = useSetState<any>({
    editVisible: false,
    relatedVisible: false,
    editTitle: '',
    orgTree: [],
    sraffStateOptions: [],
    positionTypeOptions: [],
    idcardOptions: [],
    editItem: {},
  })
  const [state1, setState1] = useSetState({
    addOpen: false,
    issueId: '',
    isEdited: false,
    modalOpen: false,
    exposureConfig: [],
    channelConfig: [],
    internalConfig: [],
    companyList: [],
    orderIssueLevelEnum: [],
  })

  const [isVisible, setIsVisible] = useState<boolean>(false)

  useEffect(() => {
    initFn()

    fetchOrg()
    fetchIdCardOptions()
    fetchPosition()
    getSelection()
    fetchExposureConfigTree()
  }, [])

  const initFn = () => {
    fastFunctionMenuSettingList().then((resp: any) => {
      let data = resp.slice(0, 8)
      let shortcutIdList = []
      let menuIdList = []
      data.map((item, index) => {
        if (item.type === 'shortcut') {
          shortcutIdList.push(item)
        } else {
          menuIdList.push(item)
        }
      })
      menuIdList.map((item, index) => {
        item.urlPath = `https://static.shjmall.cn/sass/quickEntrance${index}.png`
      })
      setShortcutIds(shortcutIdList)
      setMenuIds(menuIdList)
      setDataList([...shortcutIdList, ...menuIdList])
    })
  }

  const closeDrawer = () => {
    setVisibleDrawer(false)
    initFn()
  }

  const delFn = (id, type) => {
    fastFunctionMenuSettingAddOrDel(id, type).then(res => {
      initFn()
    })
  }

  const fetchOrg = () => {
    getOrgList().then((res: any) => {
      const orgTree = getTreeList(res, '0', [])
      setState({ orgTree })
    })
  }
  const fetchIdCardOptions = () => {
    httpDictServ({ key: 'idType', enable: 'enable' }).then((res: any) => {
      setState({ idcardOptions: res })
    })
  }
  const fetchPosition = () => {
    httpDictServ({ key: 'employeeType', enable: 'enable' }).then((res: any) => {
      setState({ positionTypeOptions: res })
    })
  }
  // 曝光渠道
  const fetchExposureConfigTree = async () => {
    getTicketsExposureConfigTree().then(res => {
      const exposureConfig = formatToTree(res, '0')
      setState1({ exposureConfig })
    })
  }
  // 获取筛选项
  const getSelection = () => {
    Promise.all([
      httpCompanyList(), // 分公司
      getEnums('crm', 'com.shj.saas.crm.domain.tickets.enums.IssueCommentStatusEnum'), // 评价结果
      getEnums('crm', 'com.shj.saas.crm.domain.tickets.enums.OrderIssueLevelEnum'), // 级别
      getEnums('crm', 'com.shj.saas.crm.domain.tickets.enums.IssueStatusEnum'), // 状态
      getTicketsChannelConfigTree(), // 渠道
      getTicketsInternalConfigTree(), // 对内分类
    ]).then(
      ([
        companyList,
        issueCommentStatusEnum,
        orderIssueLevelEnum,
        issueStatusEnum,
        channelConfig,
        internalConfig,
      ]: any) => {
        const listObj = {
          companyList,
          issueCommentStatusEnum,
          orderIssueLevelEnum,
          issueStatusEnum,
        }
        listObj['channelConfig'] = formatToTree(channelConfig, '0') // 渠道
        listObj['internalConfig'] = formatToTree(internalConfig, '0') // 对内分类
        setState1({
          channelConfig: listObj['channelConfig'],
          internalConfig: listObj['internalConfig'],
          companyList,
          orderIssueLevelEnum,
        })
      }
    )
  }

  const handleAddOk = () => {
    
  }
  return (
    <div style={{ backgroundColor: '#fff', height: '280px', marginBottom: '10px' }}>
      <div className={styles.titleBox}>
        <div className={styles.titleText}>快捷入口</div>
        {isDel ? (
          <a
            onClick={e => {
              setIsDel(false)
            }}
          >
            <Space>取消编辑</Space>
          </a>
        ) : (
          <Dropdown menu={{ items }}>
            <a onClick={e => e.preventDefault()}>
              <Space>设置</Space>
            </a>
          </Dropdown>
        )}
      </div>
      <Row gutter={[0, 30]} style={{ paddingLeft: '20px' }}>
        {dataList && dataList.length > 0 ? (
          dataList.map((item, index) => {
            return (
              <Col
                span={6}
                className={styles.iconContet}
                key={index}
                onClick={e => {
                  e.stopPropagation()
                  if (item.type === 'shortcut') {
                    if (item.key === 'shortcut1') {
                      // 新建线索
                      setAddRefRecord({})
                    } else if (item.key === 'shortcut2') {
                      // 新建员工
                      setIsVisible(true)
                      setState({ editVisible: true, editTitle: '新增' })
                    } else if (item.key === 'shortcut3') {
                      // 新建问题
                      setState1({
                        issueId: '',
                        addOpen: true,
                        isEdited: false,
                      })
                    }
                  } else {
                    navigatePage(item.application.url, item.path, navigate)
                  }
                }}
              >
                <div className={styles.iconBox}>
                  {
                    <img
                      src={item.icon ? imagePrefix + item.icon : item.urlPath}
                      className={styles.imgIcon}
                    />
                  }
                </div>
                <div className={styles.iconText}>{item.name}</div>
                {isDel ? (
                  <img
                    className={styles.iconDel}
                    src={require('@/assets/delFavorite.png')}
                    onClick={e => {
                      e.stopPropagation()
                      delFn(item.id, item.type)
                    }}
                    alt="back"
                    style={{ width: '12px', height: '12px' }}
                  />
                ) : (
                  ''
                )}
              </Col>
            )
          })
        ) : (
          <div
            className={styles.addFavorites}
            onClick={() => {
              setVisibleDrawer(true)
            }}
          >
            + 添加快捷入口
          </div>
        )}
      </Row>
      <Drawer title={`快捷入口设置`} width={500} onClose={closeDrawer} open={visibleDrawer}>
        <FavoritesList
          shortcutIds={shortcutIds}
          menuIds={menuIds}
          dataList={dataList}
          reload={() => {
            initFn()
          }}
        />
      </Drawer>

      <AddOrEditDrawer
        open={!!addRefRecord}
        onClose={() => {
          setAddRefRecord(undefined)
        }}
        data={addRefRecord}
        fn={() => {
          setAddRefRecord(undefined)
        }}
      />
      <EditDrawer
        title={state.editTitle}
        orgTree={state.orgTree}
        idcardOptions={state.idcardOptions}
        positionTypeOptions={state.positionTypeOptions}
        open={isVisible}
        record={{}}
        onClose={() => {
          setIsVisible(false)
        }}
      />

      <AddMatterModal
        open={state1.addOpen}
        onClose={() => setState1({ addOpen: false })}
        issueId={state1.issueId}
        isEdited={state1.isEdited}
        onOk={handleAddOk}
        channelConfig={state1.channelConfig}
        internalConfig={state1.internalConfig}
        exposureConfig={state1.exposureConfig}
        companyList={state1.companyList}
        orderIssueLevelEnum={state1.orderIssueLevelEnum}
      />
    </div>
  )
}
export default quickEntrance
